export enum Theme {
  DEFAULT = 'default',
  COSMIC = 'cosmic',
  CORPORATE = 'corporate',
  DARK = 'dark',
}
